import { colors, typo } from '@design-system/styles'
import styled from '@emotion/styled'

const S = {
  학습지교재구성: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 8px;

    .gray-box {
      display: flex;
      padding: 12px;
      background-color: var(--Colors-Gray-100);
      border-radius: var(--Radius-300);
      flex-wrap: wrap;
      gap: 8px;
      row-gap: 10px;

      .text-block {
        display: flex;
        align-items: center;
        gap: 8px;
      }
      .primary-color {
        color: ${colors.primary};
      }
    }

    .block {
      .primary-title {
        color: ${colors.primary};
        font-weight: 700;
      }

      .column {
        display: flex;
        align-items: center;
        &:not(:last-child) {
          margin-bottom: 12px;
        }

        .select-option {
          margin: 0 8px;
          background-color: white;
        }
      }
      > .no-pair-create {
        margin-top: -4px;
        margin-bottom: 4px;
      }
    }
  `,
  모의고사포함여부: styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    .practice-test-radio-group {
      width: 100%;
      display: flex;
    }
    .practice-test-radio-group-item {
      flex: 1;
    }
  `,
  문제타입: styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    .box {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .problem-filter-type-radio-group {
      width: 100%;
      display: flex;
    }
    .problem-filter-type-radio-group-item {
      flex: 1;
    }

    .auto-scorable-info {
      padding-top: 10px;
      text-align: center;
      color: var(--Colors-Gray-700);
      ${typo.caption01};
      font-weight: bold;
      span {
        white-space: nowrap;
      }
    }
  `,
  추가옵션: styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    .additaionl-option-row {
      display: flex;
      align-items: center;
      &.limit-problem-count-per-concept {
        display: flex;
        gap: 8px;
      }
      &.equality-level {
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
      }
    }

    .number-group {
      display: flex;
      align-items: center;
    }
    .text-with-tooltip {
      display: flex;
      align-items: center;
    }

    .equality-radio {
      margin-left: 30px;
      margin-top: 6px;
    }
  `,
  학습단계추가: styled.header`
    display: flex;
    gap: 14px;
    padding: 24px;
    background-color: var(--Colors-Blue-50, #eff6ff);

    .switch-wrapper {
      display: flex;
      align-items: center;
      column-gap: 8px;
      font-weight: 700;
      color: ${colors.blue.$300};
      label {
        user-select: none;
        cursor: pointer;
      }
    }

    > p.description {
      color: ${colors.blue.$400};
    }
  `,
  난이도: styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    .level-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .level-radio-group {
      width: 100%;
      display: flex;
    }

    .level-radio-group-item {
      flex: 1;
    }
  `,
  문제수: styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    .top {
      display: flex;
      align-items: center;
      gap: 8px;

      .sub {
        color: var(--Colors-Gray-600);
        ${typo.caption01};
      }
    }

    //TODO: 리팩토링 필요
    .problem-count-option {
      display: flex;
      justify-content: space-between;

      label {
        flex: 1;
        width: 77.25px;
        margin: 0;
        :not(:last-of-type) {
          margin-right: 8px;
        }
      }

      .problem-input {
        display: flex;
        align-items: center;
        > div {
          margin-right: 4px;
          width: 64px;
        }
        input {
          padding: 0;
          text-align: center;
          ::-webkit-outer-spin-button,
          ::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
          }
        }
      }
    }

    .problem-count-slider {
      margin-top: 10px;
    }
    .problem-count-radio-group {
      width: 100%;
      display: flex;
    }
    .problem-count-radio-group-item {
      flex: 1;
    }
  `,
  단원구성: styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    .making-unit-radio-group {
      width: 100%;
      display: flex;
      flex-direction: column;
    }
    .making-unit-radio-item {
      width: 100%;
      margin: 0 !important;
    }
  `,
  태그옵션: styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    > .header {
      display: flex;
      align-items: center;
      gap: 4px;
    }
    > .checkbox-group {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 12px;
    }
  `,
  태그옵션모달: styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 24px;
    > .header {
      display: flex;
      flex-direction: column;
      gap: 12px;

      strong {
        ${typo.body01};
      }

      .description {
        color: var(--Colors-Gray-700);
      }
    }
  `,
  문제수표시: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    flex: 0 0 64px;
    padding: 0 24px;

    border-top: 1px solid var(--Colors-Gray-300);
    background: var(--Colors-Gray-200);

    .top {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .main-text {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 4px;
      height: 24px;

      ${typo.heading05};
      font-weight: 700;
    }

    .main-problem-count {
      display: flex;
      align-items: center;
      gap: 4px;
      min-width: 30px;
    }

    .sub-text {
      font-weight: 700;
      color: var(--Colors-Gray-700);
    }

    .error-text {
      color: var(--Colors-Red-500);
      ${typo.caption01};
    }

    .primary-color {
      color: var(--Colors-Sky-400);
    }

    .error-color {
      color: var(--Colors-Red-500);
    }
  `,
  학습단계: styled.section`
    display: flex;
    flex-direction: column;
    row-gap: 16px;
    padding: 16px;
    border: 1px solid var(--Colors-Gray-300);
    border-radius: var(--Radius-300);

    .section-composition {
      display: flex;
      flex-direction: column;
      row-gap: 16px;
    }

    .section-composition__description {
      padding: 8px 0;
      text-align: center;
      border-radius: var(--Radius-100);
      background-color: var(--Colors-Slate-50, #f8fafc);
      ${typo.caption01}
      color: var(--Colors-Gray-700);

      strong {
        font-weight: 700;
        color: var(--Colors-Gray-900);
      }
    }
    .composition-bar-wrapper {
      display: grid;
      column-gap: 8px;
      margin-top: 10px;

      > div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        row-gap: 8px;
      }
    }
    .composition-table {
      display: grid;
      grid-template-columns: 140px 280px;
      grid-template-rows: 34px repeat(4, 64px) 34px;
      border: 1px solid var(--Colors-Slate-200, #e2e8f0);
      border-radius: var(--Radius-200);
      overflow: hidden; // table-header background-color 적용을 위해 추가

      > :nth-of-type(2n + 1) {
        border-right: 1px solid var(--Colors-Slate-200, #e2e8f0);
      }

      .table-header {
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 1px solid var(--Colors-Slate-200, #e2e8f0);
        background-color: var(--Colors-Slate-50, #f8fafc);
        ${typo.caption01}
        color: var(--Colors-Slate-600, #475569);
      }

      .table-column {
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 1px solid var(--Colors-Slate-200, #e2e8f0);
        padding: 0 16px;
        ${typo.body02}

        label {
          display: flex;
          align-items: center;
          column-gap: 8px;
          color: var(--Colors-Gray-700);
        }

        :nth-of-type(2n) {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          column-gap: 8px;
          padding: 0 32px;

          > span:last-of-type {
            color: var(--Colors-Gray-600);
            ${typo.caption01};
          }
        }

        label {
          user-select: none;
          cursor: pointer;
        }
      }

      .table-footer {
        grid-column: 1 / 3;
        grid-row: 6 / 7;
        display: flex;
        justify-content: center;
        align-items: center;
        column-gap: 8px;
        padding: 8px 0;
        border: none;
        ${typo.caption01}
        color: var(--Colors-Gray-600);
      }

      .gap4 {
        display: flex;
        align-items: center;
        column-gap: 4px;
      }

      .gap8 {
        display: flex;
        align-items: center;
        column-gap: 8px;
      }
    }
  `,
  ItemContainer: styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;

    padding: 24px;
  `,
}

export default S
